var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppkeyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "678.000000pt",
    height: "678.000000pt",
    viewBox: "0 0 678.000000 678.000000",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1, 0, 0, -0.1, 0, 678)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5282 6519 c-294 -126 -540 -229 -547 -229 -7 0 -45 18 -84 41 -261\n150 -626 264 -977 305 -200 24 -507 15 -704 -20 -314 -55 -616 -162 -858 -305\nl-51 -30 -513 214 c-282 118 -520 215 -531 215 -32 0 -74 -28 -86 -58 -9 -21\n-11 -309 -8 -1183 3 -1035 5 -1164 20 -1254 94 -548 319 -988 697 -1365 321\n-322 705 -544 1145 -665 873 -239 1811 -4 2446 612 211 205 348 392 478 654\n123 247 199 505 233 794 18 149 16 2339 -2 2405 -15 55 -59 100 -97 99 -15 0\n-268 -104 -561 -230z m-1644 -170 c337 -36 704 -162 977 -334 l89 -56 473 202\nc261 111 477 199 480 195 9 -9 21 -1801 12 -1804 -5 -2 -9 -53 -9 -112 0 -439\n-177 -912 -475 -1269 -355 -425 -844 -689 -1435 -772 -127 -18 -462 -15 -595\n5 -672 103 -1230 451 -1590 991 -165 246 -267 502 -327 815 -21 113 -21 136\n-25 1113 -2 548 -1 997 2 997 3 0 199 -81 436 -180 237 -99 434 -180 439 -180\n5 0 44 23 87 51 256 167 635 301 958 337 114 13 389 14 503 1z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4563 4922 c-71 -25 -129 -67 -165 -121 -95 -136 -100 -308 -15 -449\n108 -180 348 -211 495 -64 82 82 126 226 104 343 -24 129 -96 229 -199 276\n-73 33 -153 39 -220 15z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2133 4902 c-71 -25 -129 -67 -165 -121 -95 -136 -100 -308 -15 -449\n108 -180 348 -211 495 -64 82 82 126 226 104 343 -24 129 -96 229 -199 276\n-73 33 -153 39 -220 15z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3335 4606 c-220 -55 -366 -275 -326 -491 23 -127 110 -254 209 -304\nl41 -21 -25 -87 c-13 -49 -75 -270 -138 -493 l-114 -405 230 -3 c126 -1 330\n-1 453 0 l223 3 -114 405 c-63 223 -125 444 -138 493 l-25 87 41 21 c100 51\n188 180 210 308 51 297 -234 560 -527 487z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072 1593 c-18 -9 -44 -34 -57 -57 -28 -48 -340 -839 -356 -901 -9\n-35 -8 -48 6 -75 22 -43 75 -65 121 -50 40 13 44 21 99 160 l42 105 218 0 218\n0 44 -110 c51 -127 77 -159 127 -159 67 0 110 42 108 105 -1 34 -328 857 -367\n925 -40 69 -129 94 -203 57z m155 -438 c40 -110 73 -203 73 -207 0 -4 -71 -8\n-159 -8 l-158 0 68 193 c88 245 92 254 98 236 2 -8 37 -104 78 -214z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3728 1581 l-33 -29 -3 -484 c-2 -465 -2 -484 17 -515 26 -42 86 -62\n126 -42 59 29 68 55 74 211 l6 143 83 79 c71 69 84 78 96 65 7 -8 75 -111 151\n-229 76 -118 147 -225 158 -238 28 -31 83 -44 130 -31 63 17 83 71 53 143 -8\n19 -86 137 -173 263 -88 125 -163 234 -168 242 -6 11 32 53 142 160 162 157\n175 178 148 235 -27 56 -93 72 -150 37 -16 -10 -129 -122 -250 -249 l-220\n-232 -5 208 c-6 223 -13 255 -60 279 -43 22 -86 16 -122 -16z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828 1296 c-36 -27 -38 -61 -38 -539 0 -429 2 -475 18 -507 15 -31\n22 -35 60 -38 56 -4 88 17 101 65 6 21 11 109 11 197 l0 159 50 -47 c68 -64\n109 -80 200 -80 169 0 286 106 326 293 57 272 -78 495 -307 509 -67 4 -84 1\n-132 -21 -30 -13 -72 -41 -94 -61 l-41 -36 -11 44 c-6 26 -21 52 -33 60 -27\n19 -87 20 -110 2z m433 -152 c141 -71 144 -378 6 -465 -25 -16 -45 -19 -93\n-17 -74 4 -122 36 -156 101 -26 52 -36 175 -19 244 33 129 153 192 262 137z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2768 1296 c-36 -27 -38 -61 -38 -539 0 -429 2 -475 18 -507 15 -31\n22 -35 60 -38 56 -4 88 17 101 65 6 21 11 109 11 197 l0 159 50 -47 c68 -64\n109 -80 200 -80 169 0 286 106 326 293 57 272 -78 495 -307 509 -67 4 -84 1\n-132 -21 -30 -13 -72 -41 -94 -61 l-41 -36 -11 44 c-6 26 -21 52 -33 60 -27\n19 -87 20 -110 2z m433 -152 c141 -71 144 -378 6 -465 -25 -16 -45 -19 -93\n-17 -74 4 -122 36 -156 101 -26 52 -36 175 -19 244 33 129 153 192 262 137z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4933 1291 c-159 -55 -243 -189 -243 -386 0 -124 37 -222 111 -296\n140 -140 442 -139 578 1 62 64 68 139 13 158 -36 12 -64 1 -123 -52 -26 -24\n-65 -51 -86 -61 -48 -23 -137 -24 -180 -2 -44 23 -89 82 -102 133 -20 80 -37\n74 210 74 315 0 335 9 327 142 -7 125 -71 219 -186 275 -50 24 -70 28 -162 30\n-81 2 -117 -2 -157 -16z m213 -130 c58 -26 104 -101 104 -167 l0 -24 -181 0\n-181 0 7 37 c25 136 138 205 251 154z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5539 1281 c-18 -19 -29 -40 -29 -58 0 -16 60 -180 134 -366 l134\n-337 -33 -69 c-19 -38 -43 -74 -54 -80 -11 -6 -53 -11 -94 -11 -89 0 -110 -15\n-105 -77 4 -54 45 -73 157 -73 109 0 154 14 206 67 49 49 59 70 222 498 182\n476 180 469 138 511 -20 20 -33 25 -67 22 -35 -2 -46 -9 -64 -35 -11 -17 -58\n-138 -104 -270 -46 -131 -87 -249 -93 -263 -8 -22 -20 7 -88 205 -106 310\n-109 316 -135 342 -34 34 -87 31 -125 -6z",
    style: {
      fill: "rgb(70, 56, 171)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppkeyLogo);
export default __webpack_public_path__ + "static/media/appkey_logo.c4104d75936f3ce95e3e1027b0a34306.svg";
export { ForwardRef as ReactComponent };